export default {
    pleaseChoose: "Por favor selecione"
}